export default "<div class=\"spinner-container\"  *ngIf=\"loading\" id=\"loader\"><mat-spinner></mat-spinner></div>";